module.exports = __webpack_public_path__ + "assets/ckeditor.ea641b06.svg";